import React from 'react';
import PropTypes from 'prop-types';
import { Button, Card, CardBody, Heading, Text } from 'grommet';
import { useNavigate } from 'react-router-dom'; // Import the useNavigate hook from react-router-dom

export const DashboardCard = ({ card, ...rest }) => {
  const navigate = useNavigate(); // Initialize the useNavigate hook

  const { background, cta, description, descriptionColor, icon, title, url } = card;

  // Function to handle navigation on button click...
  const handleNavigate = () => {
    if (url && url.startsWith('http')) {
      // If the URL starts with 'http', open it in a new tab...
      window.open(url, '_blank');
    } else {
      // Otherwise, use React Router to navigate...
      navigate(url);
    }
  };

  return (
    <Card background={background || 'background'} fill {...rest}>
      <CardBody gap="small" align="start" flex="grow">
        {icon}
        <Heading margin="none" level={2}>
          {title}
        </Heading>
        <Text color={descriptionColor}>{description}</Text>
        {typeof cta === 'string' ? (
          <Button label={cta} onClick={handleNavigate} secondary /> // Replace href with onClick
        ) : (
          cta
        )}
      </CardBody>
    </Card>
  );
};

DashboardCard.propTypes = {
  card: PropTypes.shape({
    background: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({})]),
    cta: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    description: PropTypes.string,
    descriptionColor: PropTypes.string,
    icon: PropTypes.element,
    title: PropTypes.string,
    url: PropTypes.string,
  }).isRequired,
};
